export default __webpack_public_path__ + "static/media/TR_Printing_rules_mm.8608ba5a.pdf";